import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Whychoosenlp() {
  return (
    <section className="rapid_free_services p-100 tekrevol_dark_bg nlp_why_choose hire_ios_why_choose">
      <Container>
        <Row>
          <Col xs={12} md={8} lg={8} className="m-auto text-center">
            <h3 className="h3_head">
              Why Choose Us to Hire <span>iOS App Developers</span>
            </h3>
          </Col>
        </Row>
        <Row className="mt-sm-4 mt-md-5">
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                01
              </div>
              <div className="rapid_content">
                <h5>Expertly Vetted Talent</h5>
                <p>
                  Engage with iOS developers who have undergone rigorous
                  technical and communication assessments, ensuring they are
                  ready to meet your project needs effectively.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                02
              </div>
              <div className="rapid_content">
                <h5> Global Reach, Local Expertise</h5>
                <p>
                  Access a diverse pool of iOS app developers worldwide,
                  bringing unique perspectives and skills to your project while
                  understanding your local market requirements.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                03
              </div>
              <div className="rapid_content">
                <h5>Accelerated Hiring Process</h5>
                <p>
                  Reduce your hiring time significantly with our streamlined
                  recruitment process, enabling you to hire top iOS app
                  developers in USA within 48 hours for urgent project needs.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-xl-0 mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                04
              </div>
              <div className="rapid_content">
                <h5>Flexible Engagement Models</h5>
                <p>
                  Choose from various engagement models, including full-time,
                  part-time, or project-based hiring, allowing you to scale your
                  development team based on project demands.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4} className="mb-md-0 mb-4">
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                05
              </div>
              <div className="rapid_content">
                <h5>Cost-Efficient Solutions</h5>
                <p>
                  Benefit from competitive pricing without compromising on
                  quality. Leverage offshore development to achieve cost savings
                  while maintaining high standards.
                </p>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
            <div className="rapid_box">
              <div
                className="rapid_num"
                style={{ color: "#F47a14", fontWeight: "600" }}
              >
                06
              </div>
              <div className="rapid_content">
                <h5>Comprehensive Support</h5>
                <p>
                  From initial consultation to post-deployment support, our
                  dedicated team ensures fail-safe, future-proof iOS apps.
                  Address any technical challenges promptly to keep your project
                  on track.
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-md-4 mt-3">
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Hire iOS Developers
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychoosenlp;
